import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Refresh = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="m10.13 1.512.667 1.155-1.45.838a5.333 5.333 0 1 1-4.498.86l.671 1.163a4 4 0 1 0 3.417-.751l.884 1.532-1.154.667-2-3.464-.005-.01.038-.009 3.43-1.981Z"
      fill="currentColor"
    />
  </Icon>
));

export default Refresh;
